<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col">
                  <h4 class="card-title">Lista de Vehículos</h4>
                  <p class="card-category">Detalle</p>
                </div>
                <div style="padding-right: 15px;">
                  <button style="border: none; background-color: #004aad;"
                          class="btn btn-info btn-fill float-right" @click.prevent="popupReport=!popupReport">
                    Reportes
                  </button>
                </div>
              </div>
            </template>
            <l-table class="table-hover table-striped"
                    :columns="table1.columns"
                    :data="vehicles">
            </l-table>
            <vs-popup classContent="popup-example" title="Reporte General" :active.sync="popupReport">
              <div class="row">
                <div class="col-xl-4 col-md-4"><vs-input type="datetime-local" label="Inicio" class="inputx" v-model="formReport.inicio"/></div>
                <div class="col-xl-4 col-md-4"><vs-input type="datetime-local" label="Fin" class="inputx" v-model="formReport.fin"/></div>
                <div class="col-xl-4 col-md-4"><vs-select class="inputx" label="Evento" v-model="formReport.event">
                  <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in options1" />
                </vs-select></div>
                <div style="align-self: flex-end; padding-top: 10px;" class="col-xl-4 col-md-4">
                  <vs-button @click="exportReportGeneral()" color="#004aad" type="filled">Exportar</vs-button></div>
              </div>
            </vs-popup>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import getSecret from '../helpers/get-secret';
  const serverUrl=getSecret('SERVER_URL');
  const tableColumns = ['Cuenta', 'Placa', 'Marca', 'Modelo', 'Color', 'fecha_reporte', 'Evento']
  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        id_company:JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
        counter:JSON.parse(localStorage.getItem('jwt_licencia')).counter,
        vehicles:[],
        value1:'',
        value2:'',
        formReport:{
          id_company:JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
          inicio:"",
          fin:"",
          event:"",
        },
        options1:[
          {text:'Exceso de Velocidad',value:32},
          {text:'Desconexión de Batería',value:18},
          {text:'Geocerca de Exclusion',value:99},
          {text:'Geocerca de Inclusion',value:98},
          {text:'Pánico',value:21},
          {text:'Todos los Eventos',value:1},
        ],
        popupReport:false,
        table1: {
          columns: [...tableColumns]
        },
      }
    },
    methods:{
      validateStatus(){
        this.axios.get(serverUrl+'/api/validateStatus/'+this.id_company)
          .then(res => {   
            if(res.data.info.licencia.status_commercial == 'MORA'){
              window.localStorage.removeItem('jwt_user');
              window.localStorage.removeItem('jwt_licencia');
              window.localStorage.removeItem('jwt_token');
              location.href = location.origin+'/login';
            } else{
              let tipo = {
                "name": res.data.info.licencia.name,
                "id_company": res.data.info.licencia.id_company,
                "payment_data": res.data.info.licencia.payment_data,
                "status_commercial": res.data.info.licencia.status_commercial,
                "counter": res.data.info.licencia.counter,
              }
              window.localStorage.setItem('jwt_licencia', JSON.stringify(tipo));
              if(this.counter!=res.data.info.licencia.counter)location.reload();
            }
          })
          .catch(err => {
            console.log(err);
          })
      },
      dataVehicles(){
        this.vehicles.forEach(vehicle => {
          vehicle.fecha_reporte=vehicle.last_report;
          if(vehicle.last_event==10)vehicle.evento='Reporte Encendido';
          if(vehicle.last_event==11)vehicle.evento='Reporte Apagado';
          if(vehicle.last_event==21)vehicle.evento='Pánico';
          if(vehicle.last_event==18)vehicle.evento='Desconexión de Batería';
          if(vehicle.last_event==19)vehicle.evento='Conexión de Batería';
          if(vehicle.last_event==91)vehicle.evento='Vehículo Apagado';
          if(vehicle.last_event==90)vehicle.evento='Vehículo Encendido';
          if(vehicle.last_event==32)vehicle.evento='Exceso de Velocidad';
          if(vehicle.last_event==92)vehicle.evento='GPS apagado';
          if(vehicle.last_event==93)vehicle.evento='GPS offline';
          if(vehicle.last_event==94)vehicle.evento='GPS online';
          if(vehicle.last_event==95)vehicle.evento='Apagado por comando';
          if(vehicle.last_event==96)vehicle.evento='Encendido por comando';
          if(vehicle.last_event==97)vehicle.evento='Error de comunicación';
          if(vehicle.last_event==98)vehicle.evento='Geocerca de inclusion';
          if(vehicle.last_event==99)vehicle.evento='Geocerca de exclusion';
          if(vehicle.last_event==1)vehicle.evento='Test';
        })
      },
      exportReportGeneral(){
      let url2=serverUrl;
      let url3 = `${url2}/api/export-report-event-general/${this.formReport.id_company}/${this.formReport.inicio}/${this.formReport.fin}/${this.formReport.event}`;
      window.open(url3 , '_blank');
      }
    },
    mounted () {
      this.$root.$on("send",data=>{
        this.vehicles = data;
        this.dataVehicles();
      });
      this.$root.$emit("getList");
      this.validateStatus();
    }
  }
</script>
<style>
</style>
